// Takı: Ürünler — fotoğrafı üretilmiş katalog ürünleri. Taslağı olmayanlar
// öne çıkar; tek tıkla liste oluşturulur ya da toplu Liste Denetimi'ne gider.

import { Link } from "react-router-dom";
import { ClipboardCheck, Package } from "lucide-react";
import { ShotProductsPanel } from "../components/jewelry/ShotProductsPanel";

export default function JewelryProductsPage() {
  return (
    <div className="mx-auto max-w-7xl p-6">
      <div className="mb-5 flex flex-wrap items-center justify-between gap-3">
        <div>
          <h1 className="flex items-center gap-2 text-xl font-bold text-gray-900">
            <Package className="h-5 w-5 text-fuchsia-500" /> Ürünler
          </h1>
          <p className="mt-1 text-sm text-gray-500">Fotoğrafı üretilmiş ürünler — listesi olmayanları taslağa çevir.</p>
        </div>
        <Link to="/listing-review/jewelry" className="flex items-center gap-1.5 rounded-lg bg-fuchsia-600 px-3 py-2 text-sm font-medium text-white hover:bg-fuchsia-700">
          <ClipboardCheck className="h-4 w-4" /> Liste Denetimi
        </Link>
      </div>
      <ShotProductsPanel standalone />
    </div>
  );
}
